var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnounce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.8 758.4h-33.6V647.2h65.6v78.4c0.8 18.4-13.6 32.8-32 32.8z",
    fill: "#EC7BB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M468.8 766.4h-33.6c-4.8 0-8-3.2-8-8V647.2c0-4.8 3.2-8 8-8h65.6c4.8 0 8 3.2 8 8v78.4c0.8 22.4-17.6 40.8-40 40.8z m-25.6-16h25.6c13.6 0 24.8-11.2 24.8-24.8v-70.4h-49.6v95.2z",
    fill: "#6A576D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.4 954.4h-21.6c-6.4 0-12-5.6-12-12V647.2h150.4l-48.8 251.2c-6.4 32.8-35.2 56-68 56z",
    fill: "#938993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332 308l-132 1.6c-92.8 0-168 75.2-168 168s75.2 168 168 168l132 1.6c206.4 2.4 406.4 69.6 573.6 190.4v-720c-167.2 120.8-368 187.2-573.6 190.4z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332 308l-132 1.6c-92.8 0-168 75.2-168 168s75.2 168 168 168l132 1.6c206.4 2.4 406.4 69.6 573.6 190.4v-720c-167.2 120.8-368 187.2-573.6 190.4z",
    fill: "#FFFFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M948.8 885.6c-24 0-43.2-19.2-43.2-43.2V112.8c0-24 19.2-43.2 43.2-43.2 24 0 43.2 19.2 43.2 43.2v728.8c0 24.8-19.2 44-43.2 44z",
    fill: "#FFFFFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M948.8 69.6c-24 0-43.2 19.2-43.2 43.2v36c0-24 19.2-43.2 43.2-43.2s43.2 19.2 43.2 43.2v-36c0-24-19.2-43.2-43.2-43.2z",
    fill: "#F9F8F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M948.8 849.6c-24 0-43.2-19.2-43.2-43.2v36c0 24 19.2 43.2 43.2 43.2s43.2-19.2 43.2-43.2v-36c0 24-19.2 43.2-43.2 43.2z",
    fill: "#0D1014"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M352.8 307.2c-7.2 0-14.4 0.8-21.6 0.8l-131.2 1.6c-92.8 0-168 75.2-168 168s75.2 168 168 168l132 1.6c7.2 0 14.4 0.8 21.6 0.8V307.2z",
    fill: "#C1D840"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328.8 659.2h2.4c15.2 0 30.4-11.2 45.6-10.4V305.6c-15.2 0.8-30.4 1.6-45.6 1.6h-2.4v352z",
    fill: "#938993"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200 645.6l132 1.6c206.4 2.4 406.4 69.6 573.6 190.4v-36c-167.2-120.8-368-187.2-573.6-190.4L200 609.6C113.6 609.6 41.6 544 32.8 459.2c-0.8 6.4-0.8 12-0.8 18.4 0 92.8 75.2 168 168 168z",
    fill: "#0D1014"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M328.8 647.2v24h2.4c47.2 0.8 94.4 4.8 140.8 12l4.8-23.2c-48-8-96-12-144.8-12.8h-3.2z",
    fill: "#0D1014"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200 345.6l132-1.6c206.4-2.4 406.4-69.6 573.6-190.4v-36c-167.2 120.8-368 187.2-573.6 190.4l-132 1.6c-92.8 0-168 75.2-168 168 0 6.4 0 12 0.8 17.6C41.6 411.2 113.6 345.6 200 345.6z",
    fill: "#FFFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200 309.6c-75.2 0-138.4 48.8-160 116.8h864.8V117.6C738.4 238.4 537.6 304.8 332 308l-132 1.6z",
    fill: "#F9F8F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M948.8 69.6c-24 0-43.2 19.2-43.2 43.2v313.6H992V112.8c0-24-19.2-43.2-43.2-43.2z",
    fill: "#F9F8F6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M904.8 845.6c-1.6 0-3.2-0.8-4.8-1.6-166.4-120.8-363.2-185.6-568.8-188.8L200 653.6c-96.8 0-176-79.2-176-176s79.2-176 176-176l131.2-1.6c205.6-2.4 402.4-68 568.8-188.8 3.2-2.4 8.8-1.6 11.2 1.6 2.4 3.2 1.6 8.8-1.6 11.2-168.8 122.4-368.8 188.8-577.6 192l-132 1.6c-88 0-160 72-160 160s72 160 160 160l132 1.6c208.8 3.2 408.8 68.8 577.6 192 3.2 2.4 4 7.2 1.6 11.2-1.6 1.6-4 3.2-6.4 3.2z",
    fill: "#6A576D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M948.8 893.6c-28 0-51.2-23.2-51.2-51.2V112.8c0-28 23.2-51.2 51.2-51.2 28 0 51.2 23.2 51.2 51.2v728.8c0 28.8-23.2 52-51.2 52z m0-816c-19.2 0-35.2 16-35.2 35.2v728.8c0 19.2 16 35.2 35.2 35.2 19.2 0 35.2-16 35.2-35.2V112.8c0-19.2-16-35.2-35.2-35.2zM376.8 656.8c-4.8 0-8-3.2-8-8V314.4c-11.2 0.8-22.4 0.8-32 1.6V648c0 4.8-3.2 8-8 8s-8-3.2-8-8V308c0-4 3.2-8 8-8h2.4c13.6 0 28-0.8 44.8-1.6 2.4 0 4 0.8 5.6 2.4s2.4 4 2.4 5.6v343.2c0.8 4-2.4 7.2-7.2 7.2z",
    fill: "#6A576D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.4 962.4h-21.6c-11.2 0-20-8.8-20-20V647.2c0-4.8 3.2-8 8-8s8 3.2 8 8v295.2c0 2.4 1.6 4 4 4h21.6c29.6 0 54.4-20.8 60-49.6l46.4-238.4c0.8-4 4.8-7.2 9.6-6.4 4 0.8 7.2 4.8 6.4 9.6l-46.4 238.4c-7.2 36-39.2 62.4-76 62.4z",
    fill: "#6A576D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.ba04171a36a2e491fe6b243d132beeb1.svg";
export { ForwardRef as ReactComponent };